import axios from './axios';

/**
 * Driver Expense API Functions
 * Handles all CRUD operations for driver expense tracking
 * Manages API calls to backend driver expense endpoints
 */

// Get all expenses with optional filters
export const getAllDriverExpenses = async (filters = {}) => {
    try {
        const response = await axios.get('/driver-expenses', { params: filters });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get expenses for a specific driver by driver ID
export const getDriverExpenses = async (driverId) => {
    try {
        const response = await axios.get(`/driver-expenses/driver/${driverId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get expenses for a specific deposit by deposit ID
export const getDepositExpenses = async (depositId) => {
    try {
        const response = await axios.get(`/driver-expenses/deposit/${depositId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Get a single expense record by expense ID
export const getDriverExpenseById = async (id) => {
    try {
        const response = await axios.get(`/driver-expenses/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Create a new expense record
export const addDriverExpense = async (expenseData) => {
    try {
        const response = await axios.post('/driver-expenses', expenseData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Update an existing expense record
export const updateDriverExpense = async (id, expenseData) => {
    try {
        const response = await axios.put(`/driver-expenses/${id}`, expenseData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Delete an expense record by ID
export const deleteDriverExpense = async (id) => {
    try {
        const response = await axios.delete(`/driver-expenses/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}; 